import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPenNib = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 17 16"
    {...props}
  >
    <path
      fill="#4B7EFF"
      d="M15.406 3c.781.75.781 1.969 0 2.75l-2.875 2.875-.875 3.125c-.156.563-.75 1.156-1.312 1.344L1.625 16 0 14.375l2.906-8.719c.188-.562.781-1.156 1.344-1.312l3.125-.875L10.25.594A1.97 1.97 0 0 1 11.625 0c.5 0 1 .219 1.375.594zm-5.187 8.344.875-3.125v-.031L7.813 4.906H7.78l-3.125.875a.62.62 0 0 0-.343.344l-2.407 7.281 3.219-3.25C5.031 9.97 5 9.75 5 9.5A1.5 1.5 0 0 1 6.5 8C7.313 8 8 8.688 8 9.5A1.5 1.5 0 0 1 6.5 11c-.25 0-.469-.031-.656-.125l-3.25 3.219 7.281-2.406a.62.62 0 0 0 .344-.344m4.125-6.656c.187-.188.187-.47 0-.625l-2.406-2.407c-.25-.25-.532-.093-.626 0L9 3.97 12.031 7z"
    />
  </svg>
);
export default SvgPenNib;
